import { useRouter } from 'vue-router';

const useJump = () => {
  const router = useRouter();
  const jump = (path: string) => {
    router.push({
      path,
    });
  };
  return jump;
};

export default useJump;
